// *******************************************************
// Interface Exports File
// -------------------------------------------------------

// *******************************************
// Component Imports
// -------------------------------------------
import asFoodItem_ from './asFoodItem';
// --------------------------------

// *******************************************
// Exports
// -------------------------------------------
export const asFoodItem = asFoodItem_;
// --------------------------------



// WEBPACK FOOTER //
// ./src/interface/index.js